module.exports = __webpack_public_path__ + "static/media/es-ecosentino-bathroom-days-small.bd57de0c.png";